import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, pipe } from 'rxjs';
import * as R from 'runtypes';

import { URLS } from 'commons/app.constant';
import { AccountType, BankDetail, BankType } from 'settings/bank-details/bank-details.model';
import { ApiFiatTransferPurposeCode, FiatTransferPurposeCode } from 'entities/purpose.code';

export type EditableBankDetail = {
  id: number | null;
  name?: string;
  bankType: BankType;
  accountType: AccountType;
  referenceText?: string;
  accountNumber?: string;
  bankName?: string;
  bankAddress?: string;
  wireRoutingNumber?: string | null;
  achRoutingNumber?: string | null;
  swiftCode?: string | null;
};

const ArrayOfDict = R.Array(R.Dictionary(R.Union(R.Number, R.String, R.Boolean, R.Null)));
const bankListResponse = pipe(
  map(ArrayOfDict.check),
  map((response) => response.map((r) => new BankDetail(r)))
);

@Injectable({
  providedIn: 'root',
})
export class BankService {
  constructor(private readonly http: HttpClient) {}

  getBankDetails(): Observable<Array<BankDetail>> {
    return this.http.get(URLS.listBankDetails).pipe(bankListResponse);
  }

  getWireBankDetails(): Observable<Array<BankDetail>> {
    return this.http.get(URLS.listWireBankDetails).pipe(bankListResponse);
  }

  getWirePurposeCodes(): Observable<Array<FiatTransferPurposeCode>> {
    return this.http.get(URLS.listWirePurposeCodes).pipe(map(R.Array(ApiFiatTransferPurposeCode).check));
  }

  getAchBankDetails(): Observable<Array<BankDetail>> {
    return this.http.get(URLS.listAchBankDetails).pipe(bankListResponse);
  }

  saveBankdetails(bankDetailsObj: EditableBankDetail): Observable<BankDetail> {
    return this.http
      .post(URLS.saveBankDetails, {
        ...bankDetailsObj,
        // don't update default bank
        isDefault: undefined,
      })
      .pipe(map((response) => new BankDetail(response)));
  }

  deleteBankDetails(bankId: number): Observable<void> {
    return this.http.post<void>(URLS.removeBankDetails, { id: bankId });
  }
}
